import type { To } from 'react-router';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import styles from './EmptyFilteredHosts.module.css';

type Props = {
  hostNoun: 'host' | 'lighthouse' | 'relay';
  clearFiltersHref: To;
};

export function EmptyFilteredHosts({ hostNoun, clearFiltersHref }: Props) {
  return (
    <CenteredLayout className={styles.EmptyFilteredHosts}>
      <div>
        <h2 className="h3 mb-16">No results found</h2>
        <p className="p-lt mb-24">To see all your {hostNoun}s, clear the filters.</p>
        <LinkButton to={clearFiltersHref} variant="secondary">
          Clear filters
        </LinkButton>
      </div>
    </CenteredLayout>
  );
}
